module.exports = __webpack_public_path__ + "assets/img/pandapakita-logo.c8651008.png";